// Path: ./src/app/components/ExportExcelButton/index.tsx
import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

interface Props {
  /**
   * Handles the click event to export data to an Excel file.
   */
  onExportClick?: () => void;
  onImportExcelClick?: () => void;
}
export const ExportExcelButton = ({
  onExportClick,
  onImportExcelClick,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  /**
   * Handles the click event of a Export button.
   * Opens an export dropdowns options
   * @param event React.MouseEvent<HTMLButtonElement>
   */

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Handles the click event of a Export button.
   * close an export dropdowns options
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div data-testid="exportexcelbutton-test-id">
      <Button
        id="export-button"
        aria-controls={open ? "export-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ textTransform: "capitalize" }}
        startIcon={<DownloadIcon></DownloadIcon>}
      >
        Excel
      </Button>
      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "export-button",
        }}
      >
        <MenuItem
          onClick={onExportClick}
          data-testid="exportexcelbutton-test-id-export"
        >
          Export Excel
        </MenuItem>
        <MenuItem
          onClick={onImportExcelClick}
          data-testid="exportexcelbutton-test-id-import"
        >
          Import Excel
        </MenuItem>
      </Menu>
    </div>
  );
};
